export default {
  machineEggp: {
    56: '0x261008E08Bf6BE490F4DD46d99490F5a2E96E9c4', //'0xbe4c35C1E37cd1cca9D9EFb5684c2E585696AFB5',
    97: '0x4D240f17BDa07058a6868F9aE22B5409CDE518Cf'//'0xeBA712B607357F0FCC0cE90AEF1a13EFfc00c3D4'
  },
  machineCake: {
    56: '0xec92EB944C02075bAF1DAA44e393D102062cCA2c',
    97: '0x8f7e97e3eE6062d6771678CdfC3585E97752C7bb'//'0x528D966413cC8f1AEcE61302CC04c99B507990fC'
  },
  machineBUSD: {
    56: '0x2b4aF6328410e22204c38916719A82a459b251C8',
    97: '0x8f7e97e3eE6062d6771678CdfC3585E97752C7bb'//'0x528D966413cC8f1AEcE61302CC04c99B507990fC'
  },
  tokenEprt: {
    56: '0x21adB1c644663069e83059AC3f9d9Ca1133D29e4',
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'
  },
  tokenEggp: {
    56: '0x21adB1c644663069e83059AC3f9d9Ca1133D29e4', //'0x21adB1c644663069e83059AC3f9d9Ca1133D29e4',
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee' //'0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'
  },
  tokenCake: {
    56: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'//'0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'
  },
  tokenBUSD: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'//'0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee'
  }
}
